<div id="top" class="main">
  <div *ngIf="isPreviewMode && !underMaintenance" class="isPreviewModeBanner"
    [ngClass]="{'is-phone-portrait': isPhonePortrait, 'is-preview-mode': isPreviewMode}">
    <p i18n="Banner text|Text that is displayed only when in preview mode of the questionnaire.">This is a <b>Preview
        assessment</b>. The data submitted in preview won't appear in your reports.</p>
  </div>
  <div *ngIf="!isSurveyInstrumentsUnderMaintenance && isSurveyInstrumentsHeadsupEnabled && !isPreviewMode && !underMaintenance"  [ngClass]="{'is-phone-portrait': isPhonePortrait}"  class="isPreviewModeBanner"
  [ngClass]="{'is-phone-portrait': isPhonePortrait, 'is-preview-mode': isPreviewMode}">
    <p>{{getLocalizedSurveyInstrumentsHeadsupStatement}}</p>
  </div>

  <div class="header">
    <app-header></app-header>
  </div>

  <div class="intro-page"
    [ngClass]="{
      'is-phone-portrait': isPhonePortrait, 
      'is-preview': isPreviewMode,
      'is-preview-and-portrait': isPreviewMode && isPhonePortrait
    }">
    <mat-card>
      <mat-card-content class="content">
        <router-outlet></router-outlet>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="footer">
    <app-footer></app-footer>
  </div>
</div>
